import { useUserStore } from '@/store/modules/user'

const storageKey = (templateId: string | number) => {
  const user = useUserStore()
  if (!user.hasLogged || user.getTenant == null || user.getDept == null || templateId == null) return null
  return `his:prescription-header:v1:${JSON.stringify([user.getTenant, user.getDept, templateId])}`
}

export const readChinesePrescriptionNumber = (templateId: string | number): boolean => {
  const key = storageKey(templateId)
  return Boolean(key && localStorage.getItem(key) === 'true')
}

export const saveChinesePrescriptionNumber = (templateId: string | number, enabled: boolean) => {
  const key = storageKey(templateId)
  if (!key) throw new Error('无法保存本机处方序号设置，请确认已登录机构并加载打印模板')
  localStorage.setItem(key, String(enabled))
}

export const isPrescriptionDocumentTitleVisible = (config: { headerInfo?: boolean }) => config.headerInfo === true

const chineseNumber = (number: number): string => {
  const digits = '零一二三四五六七八九'
  for (const [base, unit] of [[100000000, '亿'], [10000, '万'], [1000, '千'], [100, '百'], [10, '十']] as const) {
    if (number < base) continue
    const remainder = number % base
    const prefix = base === 10 && number < 20 ? '' : chineseNumber(Math.floor(number / base))
    return `${prefix}${unit}${remainder ? `${remainder < base / 10 ? '零' : ''}${chineseNumber(remainder)}` : ''}`
  }
  return digits[number]
}

export const formatChinesePrescriptionNumber = (order: number): string => `处方${chineseNumber(order)}`
